/**
 * cld-estimate-request.js
 * 見積もり依頼モーダル
 * - フォーム入力情報・見積もり金額・カート情報を収集
 * - Shopify /contact フォームに POST
 */
(function () {
	"use strict";

	var btn = document.querySelector('[id^="cld-quote-btn-"]');
	if (!btn) return;

	var sectionId = btn.dataset.section;

	/* ── モーダル HTML を挿入 ── */
	var modal = document.createElement("div");
	modal.id = "cld-quote-modal";
	modal.className = "cld-quote-modal";
	modal.setAttribute("aria-modal", "true");
	modal.setAttribute("role", "dialog");
	modal.innerHTML = [
		'<div class="cld-quote-modal-inner">',
		'  <button type="button" class="cld-quote-modal-close" aria-label="閉じる">×</button>',
		'  <div id="cld-quote-modal-body">',
		'    <h2 class="cld-quote-modal-title">見積もりを依頼する</h2>',
		'    <p class="cld-quote-modal-note">以下の内容でお見積もりを依頼します。内容をご確認の上、メールアドレスを入力して送信してください。</p>',
		'    <div id="cld-quote-preview" class="cld-quote-preview"></div>',
		'    <div class="cld-quote-field-wrap">',
		'      <label class="cld-quote-field-label" for="cld-quote-company">会社名 <span class="cld-quote-required">必須</span></label>',
		'      <input type="text" id="cld-quote-company" class="cld-quote-field-input" placeholder="株式会社〇〇" required>',
		'    </div>',
		'    <div class="cld-quote-field-wrap">',
		'      <label class="cld-quote-field-label" for="cld-quote-fullname">氏名 <span class="cld-quote-required">必須</span></label>',
		'      <input type="text" id="cld-quote-fullname" class="cld-quote-field-input" placeholder="山田 太郎" required>',
		'    </div>',
		'    <div class="cld-quote-field-wrap">',
		'      <label class="cld-quote-field-label" for="cld-quote-tel">電話番号 <span class="cld-quote-required">必須</span></label>',
		'      <input type="tel" id="cld-quote-tel" class="cld-quote-field-input" placeholder="000-0000-0000" required>',
		'    </div>',
		'    <div class="cld-quote-field-wrap">',
		'      <label class="cld-quote-field-label" for="cld-quote-email">メールアドレス <span class="cld-quote-required">必須</span></label>',
		'      <input type="email" id="cld-quote-email" class="cld-quote-field-input" placeholder="info@example.com" required>',
		'      <p class="cld-quote-email-note">店舗からの返信がこのアドレスに届きます。</p>',
		'    </div>',
		'    <div class="cld-quote-field-wrap">',
		'      <label class="cld-quote-field-label" for="cld-quote-notes">その他 <span class="cld-quote-optional">任意</span></label>',
		'      <textarea id="cld-quote-notes" class="cld-quote-field-textarea" rows="4" placeholder="見積に関して必要事項をご記入ください。"></textarea>',
		'    </div>',
		'    <button type="button" id="cld-quote-submit" class="cld-quote-submit-btn">送信する</button>',
		"  </div>",
		'  <div id="cld-quote-thanks" class="cld-quote-thanks hidden">',
		'    <p class="cld-quote-thanks-icon">✓</p>',
		'    <h2 class="cld-quote-modal-title">送信しました</h2>',
		'    <p class="cld-quote-thanks-text">見積もり依頼を受け付けました。<br>担当者より折り返しご連絡いたします。</p>',
		'    <button type="button" class="cld-quote-modal-close cld-quote-close-btn">閉じる</button>',
		"  </div>",
		"</div>",
	].join("");
	document.body.appendChild(modal);

	/* ── ヘルパー ── */
	function qs(id) {
		return document.getElementById(id);
	}

	function formatPrice(cents) {
		return "¥" + Math.round(cents / 100).toLocaleString("ja-JP");
	}

	function textOf(id) {
		var el = qs(id);
		return el ? el.textContent.trim() : "";
	}

	function valueOf(selector) {
		var el = document.querySelector(selector);
		return el && !el.disabled ? el.value.trim() : "";
	}

	function isVisible(id) {
		var el = qs(id);
		return el && !el.classList.contains("hidden");
	}

	/* ── フォーム情報を収集してプレビュー文字列を生成 ── */
	function parseYen(text) {
		if (!text) return 0;
		var s = text.replace(/[¥￥,、]/g, "").replace(/[^0-9\-]/g, "");
		return parseInt(s, 10) || 0;
	}

	function formatYen(n) {
		return "¥" + n.toLocaleString("ja-JP");
	}

	function buildPreview() {
		var sid = sectionId;
		var lines = [];

		/* 商品名・商品コード */
		var productTitle = document.title.replace(/ *[–—-] *.+$/, "").trim();
		var skuEl = document.querySelector(".cld-pdp-sku");
		var sku = skuEl ? skuEl.textContent.trim() : "";

		/* 数量 */
		var qtyEl = document.querySelector(".cld-qty-select");
		var qty = qtyEl ? parseInt(qtyEl.value, 10) : 0;

		/* 見積もり金額を計算 */
		var base = parseYen(textOf("cld-est-base-" + sid));
		var colorFee = isVisible("cld-est-color-row-" + sid) ? parseYen(textOf("cld-est-color-" + sid)) : 0;
		var expressFee = isVisible("cld-est-express-row-" + sid) ? parseYen(textOf("cld-est-express-" + sid)) : 0;
		var campaignDiscount = isVisible("cld-est-campaign-row-" + sid) ? Math.abs(parseYen(textOf("cld-est-campaign-" + sid))) : 0;
		var subtotal = base + colorFee + expressFee - campaignDiscount;
		var unitPrice = qty > 0 ? Math.round(subtotal / qty) : 0;
		var tax = Math.floor(subtotal * 0.1);
		var total = subtotal + tax;

		lines.push("■ お見積もり内容");
		lines.push("商品名: " + productTitle);
		if (sku) lines.push("商品コード: " + sku);
		lines.push("商品URL: " + decodeURIComponent(window.location.href));
		lines.push("数量: " + qty + "部");
		lines.push("1冊単価: " + formatYen(unitPrice));
		lines.push("小計: " + formatYen(subtotal));
		lines.push("消費税: " + formatYen(tax));
		lines.push("合計: " + formatYen(total));
		lines.push("");

		/* 顧客情報 */
		var customerLines = [];
		[
			"企業名",
			"担当者名",
			"郵便番号",
			"都道府県",
			"市区町村",
			"丁目・地番",
			"電話番号",
			"FAX番号",
			"ホームページURL",
			"メールアドレス",
		].forEach(function (label) {
			var val = valueOf('[name="properties[' + label + '（顧客）]"]');
			if (val) customerLines.push(label + ": " + val);
		});
		if (customerLines.length) {
			lines.push("■ 顧客情報");
			lines = lines.concat(customerLines);
			lines.push("");
		}

		/* 名入れ情報 */
		lines.push("■ 名入れ情報");
		var history = document.querySelector(
			'[name="properties[注文履歴]"]:checked'
		);
		lines.push("注文履歴: " + (history ? history.value : "未選択"));
		lines.push(
			"名入れ色: " + (textOf("cld-color-trigger-text-" + sid) || "未選択")
		);
		lines.push(
			"名入れ書体: " + (textOf("cld-imprint-font-text-" + sid) || "未選択")
		);
		lines.push(
			"名入れパターン: " +
				(textOf("cld-imprint-pattern-text-" + sid) || "未選択")
		);

		var expressCheck = qs("cld-express-check-" + sid);
		var expressField = qs("cld-express-field-" + sid);
		if (expressField && !expressField.classList.contains("hidden")) {
			lines.push(
				"特急対応: " + (expressCheck && expressCheck.checked ? "あり" : "なし")
			);
		}

		var fields = [
			["会社情報", "会社情報"],
			["企業名", "企業名"],
			["郵便番号", "郵便番号"],
			["都道府県", "都道府県"],
			["市区町村", "市区町村"],
			["丁目・地番", "丁目・地番"],
			["電話番号", "電話番号"],
			["FAX番号", "FAX番号"],
			["ホームページURL", "ホームページURL"],
			["メールアドレス（会社）", "メールアドレス（会社）"],
			["希望納期", "希望納期"],
			["希望記載情報等", "希望記載情報"],
			["ご要望・お問合せ", "ご要望・お問い合わせ"],
		];
		fields.forEach(function (pair) {
			var val = valueOf('[name="properties[' + pair[1] + ']"]');
			if (val) lines.push(pair[0] + ": " + val);
		});

		return lines;
	}

	/* ── カート情報を取得してプレビューに追記 ── */
	function buildCartLines(cartData) {
		var lines = [];
		lines.push("");
		lines.push("■ 現在のカート内容");
		var allItems = cartData.items || [];
		var items = allItems.filter(function (item) {
			return !(item.properties && item.properties["_fee_for"]);
		});
		if (items.length === 0) {
			lines.push("（カートは空です）");
		} else {
			var feeByKey = {};
			allItems.forEach(function (item) {
				if (item.properties && item.properties["_fee_for"]) {
					var key = item.properties["_fee_for"];
					if (!feeByKey[key]) feeByKey[key] = [];
					feeByKey[key].push(item);
				}
			});
			items.forEach(function (item) {
				var itemTotal = item.line_price;
				var fees = feeByKey[item.key] || [];
				fees.forEach(function (fee) { itemTotal += fee.line_price; });
				var discounts = item.discount_allocations || [];
				discounts.forEach(function (d) {
					var amount = d.amount ? parseInt(d.amount, 10) : 0;
					if (amount > 0) itemTotal -= amount;
				});
				var unitPrice = Math.round(itemTotal / (item.quantity || 1) / 100);
				var sku = item.sku || "";
				lines.push(item.product_title + (sku ? " (" + sku + ")" : "") + " " + item.quantity + "部 @" + formatYen(unitPrice));
			});
		}
		return lines;
	}

	/* ── プレビューを表示 ── */
	function renderPreview(lines) {
		var preview = qs("cld-quote-preview");
		if (!preview) return;
		preview.textContent = lines.join("\n");
	}

	/* ── モーダルを開く ── */
	function openModal() {
		var lines = buildPreview();
		renderPreview(lines.concat(["", "（カート情報を読み込み中...）"]));
		modal.classList.add("is-open");
		document.body.style.overflow = "hidden";

		fetch("/cart.js")
			.then(function (r) {
				return r.json();
			})
			.then(function (cart) {
				renderPreview(lines.concat(buildCartLines(cart)));
			})
			.catch(function () {
				renderPreview(lines.concat(["", "（カート情報の取得に失敗しました）"]));
			});
	}

	/* ── モーダルを閉じる ── */
	function closeModal() {
		modal.classList.remove("is-open");
		document.body.style.overflow = "";
		/* リセット */
		setTimeout(function () {
			var body = qs("cld-quote-modal-body");
			var thanks = qs("cld-quote-thanks");
			if (body) body.classList.remove("hidden");
			if (thanks) thanks.classList.add("hidden");
			["cld-quote-company","cld-quote-fullname","cld-quote-tel","cld-quote-email","cld-quote-notes"].forEach(function(id) {
				var el = qs(id); if (el) el.value = "";
			});
		}, 300);
	}

	/* ── 送信 ── */
	function submitQuote() {
		var companyInput  = qs("cld-quote-company");
		var fullnameInput = qs("cld-quote-fullname");
		var telInput      = qs("cld-quote-tel");
		var emailInput    = qs("cld-quote-email");
		var notesInput    = qs("cld-quote-notes");

		var requiredFields = [companyInput, fullnameInput, telInput, emailInput];
		for (var i = 0; i < requiredFields.length; i++) {
			var f = requiredFields[i];
			if (!f || !f.value.trim() || !f.validity.valid) {
				if (f) { f.focus(); f.reportValidity(); }
				return;
			}
		}

		var submitBtn = qs("cld-quote-submit");
		submitBtn.disabled = true;
		submitBtn.textContent = "送信中...";

		var preview = qs("cld-quote-preview");
		var bodyText = [
			"■ お客様情報",
			"会社名：" + companyInput.value.trim(),
			"氏名："   + fullnameInput.value.trim(),
			"電話番号：" + telInput.value.trim(),
			"メール："  + emailInput.value.trim(),
			"",
			"■ その他・ご要望",
			notesInput.value.trim(),
			"",
			(preview ? preview.textContent : ""),
			"",
			"※ このメールは見積もり依頼の内容です。ご返信をお待ちください。"
		].join("\n");
		var email = emailInput.value.trim();

		var contactForm = document.getElementById("cld-quote-form");
		var emailField = document.getElementById("cld-quote-form-email");
		var bodyField = document.getElementById("cld-quote-form-body");

		if (!contactForm || !emailField || !bodyField) {
			submitBtn.disabled = false;
			submitBtn.textContent = "送信する";
			alert("フォームの初期化に失敗しました。ページを再読み込みしてください。");
			return;
		}

		emailField.value = email;
		bodyField.value = bodyText;

		var imgEl = document.querySelector('.product__media img, .product-single__photo img');
		var productImageUrl = imgEl ? imgEl.src : '';
		if (productImageUrl.indexOf('//') === 0) productImageUrl = 'https:' + productImageUrl;
		var productImagesHtml = productImageUrl
			? '<img src="' + productImageUrl + '" width="100" style="max-width:100px;margin:0 0 12px;border-radius:4px;vertical-align:top;" alt="商品画像">'
			: '';

		fetch('https://api.emailjs.com/api/v1.0/email/send', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				service_id: 'service_jssou81',
				template_id: 'template_6d5b15x',
				user_id: 'CCjjuY4LqzkYNnLNR',
				template_params: {
					to_email: email,
					email: email,
					company_name: companyInput.value.trim(),
					customer_name: fullnameInput.value.trim(),
					body: (preview ? preview.textContent : '') + (notesInput.value.trim() ? '\n\n■ その他・ご要望\n' + notesInput.value.trim() : ''),
					product_images_html: productImagesHtml
				}
			})
		}).finally(function () {
			/* form.submit() はCAPTCHAハンドラをバイパスするため
			   submitイベントをdispatchしてShopifyのスクリプトに処理させる */
			contactForm.dispatchEvent(
				new Event("submit", { bubbles: true, cancelable: true })
			);
		});
	}

	/* ── 送信後のリダイレクトで戻ってきた場合にトースト表示 ── */
	if (window.location.search.indexOf("estimate=sent") !== -1) {
		var toast = document.createElement("div");
		toast.className = "cld-quote-toast";
		toast.textContent =
			"見積もり依頼を受け付けました。ご入力のメールアドレスへ担当者よりご連絡いたします。";
		document.body.appendChild(toast);
		setTimeout(function () {
			toast.classList.add("is-visible");
		}, 100);
		setTimeout(function () {
			toast.classList.remove("is-visible");
			setTimeout(function () {
				toast.remove();
			}, 400);
			/* URLから ?estimate=sent を除去 */
			var clean = window.location.pathname + window.location.hash;
			history.replaceState(null, "", clean);
		}, 5000);
	}

	/* ── イベント ── */
	btn.addEventListener("click", openModal);

	modal.addEventListener("click", function (e) {
		if (e.target === modal) closeModal();
	});

	document.addEventListener("click", function (e) {
		if (e.target.classList.contains("cld-quote-modal-close")) closeModal();
	});

	document.addEventListener("keydown", function (e) {
		if (e.key === "Escape" && modal.classList.contains("is-open")) closeModal();
	});

	var submitBtn = qs("cld-quote-submit");
	if (submitBtn) submitBtn.addEventListener("click", submitQuote);
})();
